import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink
} from "reactstrap";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import { taskmanageService } from "../../services/taskmanageService";
import 'assets/css/themecustom-style.css';
import Paginationcomponent from "components/Paginationcomponent.js"
const MismailLog = (props) => {
  const [currentPage, setCurrentPage] = useState(null);
  const [last_page, setLastPageData] = useState(0);
  const [misMailData , setMisMailData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [total_page,setTotalData] = useState(0);
  const rowsPerPageOptions = [5, 10, 25, 50, 100];
  const params  = useParams();

  const handlePageClick = (e, index) => {
    e.preventDefault();
    get_archive_list(index,rowsPerPage);
  };

  const handlePreviousClick = () => {
    const prev = currentPage - 1;
    get_archive_list(prev,rowsPerPage);
  };

  const handleNextClick = () => {
    const next = currentPage + 1;
    get_archive_list(next,rowsPerPage);
  };

  const get_archive_list = async (pageNumber = 1,rowsPerPage='') => { 
    let id = params.id;
    taskmanageService.getMisMailDetails(pageNumber,rowsPerPage,id).then((response) => {
        console.log(response.data.data.data)
        setMisMailData(response.data.data.data);
      setCurrentPage(response.data.current_page);
      setLastPageData(response.data.last_page);
      setTotalData(response.data.total);
    });
  };

  const restoreTask = (id,index) => {
    taskmanageService.restoreTask(id).then((response) => {
      if(response.status == 200){
        let state = [...archivedata];
        delete state[index];
        setArchivedata(state);
       toast.success(response.data.message);
      }else{
        toast.error(response.data.message);
      }
    });
  }

  const formatDate = (dateStr) => {
    if(dateStr!=null && dateStr!=''){
      const [year, month, day] = dateStr.split('-');
      let newDate = `${day}-${month}-${year}`;
      return newDate;
    }
  };

  useEffect(() => {
    get_archive_list();
}, []);

const handleRowsPerPageChange = (newRowsPerPage) => {

  setRowsPerPage(newRowsPerPage);
  
  setCurrentPage(1); 
  get_archive_list(1,newRowsPerPage)

};
const wrapstyle = {
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
  };
  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        
      
        <Row className="mt-5">
          <div className="col" style={{padding:'0%'}}>
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="filter" style={{padding:'0 3%'}}>
                    <h3 className="mb-0" style={{fontSize:'20px'}}>Mis Mail Log</h3><br></br>
                    <br></br>
                </Row>
               
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                <th style={{ width: '25%' }}>Mail To</th>
                <th style={{ width: '25%' }}>Mail From</th>
                <th style={{ width: '25%'  }}>Mail CC</th>
                <th style={{ width: '25%' }}>Body</th>
                </thead>
                <tbody>
                  {misMailData &&
                    misMailData.length &&
                    misMailData != null ? (
                        misMailData.map((item, i) => (
                      <>
                     <tr className={((i % 2 == 0)? 'blue-row':(i % 3 == 0)?'purple-row':'orange-row') }>
                     <td  className="noofjob">{item.mailto}</td>
                  <td  className="noofjob">{item.mailfrom}</td>
                  <td style={wrapstyle}>{item.mailcc}</td>
                  <td style={wrapstyle}>{item.data || 'N/A'}</td>
                     </tr>
                      
                      </>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={3}>No Data Found!</td>
                    </tr>
                  )}
                </tbody>
              </Table>

              <CardFooter className="py-4">
                <nav aria-label="...">
                  <Pagination
                    className="pagination justify-content-end mb-0"
                    listClassName="justify-content-end mb-0"
                  >
                    <PaginationItem disabled={currentPage <= 1}>
                      <PaginationLink onClick={handlePreviousClick} previous />
                    </PaginationItem>
                    {[...Array(last_page)].map((page, i) => (
                      <PaginationItem
                        active={i + 1 === currentPage}
                        key={i + 1}
                      >
                        <PaginationLink
                          onClick={(e) => handlePageClick(e, i + 1)}
                        >
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    ))}
                    <PaginationItem disabled={currentPage >= last_page}>
                      <PaginationLink onClick={handleNextClick} next />
                    </PaginationItem>
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
      
      </Container>
    </>
  );
};


export default MismailLog;
